import BaseSerializer from './Base';
import {toSize} from 'ol/size';
import XYZ from 'ol/source/XYZ';
import {isDefined} from '@config/utils';

class XYZSerializer extends BaseSerializer {
    constructor() {
        super();
        this.sourceCls = XYZ;
        this.allowedImageExtensions = ['png', 'jpg', 'gif'];
    }

    serialize(layer, source) {
        this.validateSource(source);
        let tileGrid = source.getTileGrid();
        let serialized = {
            baseURL: source.getUrls() ? source.getUrls()[0] : window.location.href.split(/[?#]/)[0].replace(/^\/|\/$/g, ''),
            opacity: layer.getOpacity(),
            imageExtension: this.getImageExtensionFromSource(source)
                || 'png',
            resolutions: tileGrid.getResolutions(),
            tileSize: toSize(tileGrid.getTileSize()),
            type: 'OSM'
        };
        return serialized;
    }

    /**
     * Returns the file extension from the url and compares it to whitelist.
     * Sources with an tileUrlFunction are currently not supported.
     *
     * @private
     * @param {ol.source.XYZ} source An ol.source.XYZ.
     * @return {String} The fileExtension or `false` if none is found.
     */
    getImageExtensionFromSource(source) {
        let urls = source.getUrls();
        let url = urls ? urls[0] : '';

        const checkIfFile = (url) => {
            url = new URL(url);
            return url.pathname.split('/').pop().indexOf('.') > 0;
        }

        // GOOGLE EXAMPLE: https://mt0.google.com/vt/lyrs=y&x={x}&y={y}&z={z}
        // ESRI EXAMPLE https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}
        // NOMARL XYZ https://{a-c}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png

        if (isDefined(url)) {
            if(checkIfFile(url)) {
                let extension = url.substr(url.length - 3);
                if(this.allowedImageExtensions.includes(extension)) {
                    return extension;
                }else{
                    this.raiseException('Invalid extension supplied for ' + source.constructor.name);
                    return false;
                }
            }else{
                return null;
            }
        }

        this.raiseException('No url(s) supplied for ' + source.constructor.name);
        return false;
    }

    validateSource(source) {
        if (!(source instanceof this.sourceCls)) {
            this.raiseException('Cannot serialize this source with this serializer');
        }
        if (source.getUrls() === null) {
            this.raiseException('Cannot serialize this source without an URL. ' +
                'Usage of tileUrlFunction is not yet supported');
        }
    }
};

export default XYZSerializer;